import React, { useContext } from "react";
import { ListItem, ListItemText, Box } from "@mui/material";
import { ThemeContext } from "../../context/ThemeContext";
import { getColors } from "../../themes/theme";
import { useNavigate, useParams } from "react-router-dom";
import { useProtocolData } from "../../hooks/protocoldata/useProtocolData";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import { isEmpty } from "../../utils/isEmpty";
import useMediaQuery from "@mui/material/useMediaQuery";

export const MainList = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { mainId } = useParams();
  const { token } = useAuthContext();
  const { areas } = useProtocolData(token);
  const navigate = useNavigate();
  const { darkMode } = useContext(ThemeContext);

  const listItems = isEmpty(data)
    ? areas
    : Object.keys(data).map((key) => ({ area: key }));

  const handleItemClick = (selectedId) => {
    navigate(`/exercise/${selectedId}`, {
      state: {
        exerciseData: data,
      },
    });
  };

  return (
    <Box
      sx={{
        display: isMobile ? "none" : "block",
        height: "100%",
        width: { xs: "166px", lg: "260px" },
        minWidth: { xs: "166px", lg: "260px" },
        px: { xs: "10px", lg: "20px" },
        pt: 2,
        borderRight: `1px solid ${
          darkMode ? getColors.appBarBorderDark : getColors.appBarBorderLight
        }`,
      }}
    >
      {listItems.map((item, index) => (
        <ListItem
          key={index}
          onClick={() => handleItemClick(item.area)}
          sx={{
            fontSize: { xs: "20px", lg: "22px" },
            px: { xs: "20px", lg: "28px" },
            py: { xs: "10px", lg: "14px" },
            mb: 1,
            background:
              mainId === item.area ? getColors.listItemHoverBg : "transparent",
          }}
        >
          <ListItemText
            primary={item.area}
            sx={{
              "& .MuiListItemText-primary": {
                color: mainId === item.area && getColors.primaryTextDark,
              },
            }}
          />
        </ListItem>
      ))}
    </Box>
  );
};
